import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { NavigationService } from 'src/app/shared/services/navigation.service';

@Component({
  selector: 'app-back',
  templateUrl: './back.component.html',
  styleUrls: ['./back.component.scss']
})
export class BackComponent implements OnInit {

  public history: any[] = [];

  constructor(private location: Location, private router: Router, private navigationService: NavigationService) { }

  ngOnInit(): void {
    this.history = this.navigationService.getNavigationHistory();
  }
  
  goBack() {
    if (this.history.length > 1) {
      this.location.back();
    }
  }
  
}
